import { render, staticRenderFns } from "./ServerErrorArea.vue?vue&type=template&id=b112bd7e&scoped=true&"
import script from "./ServerErrorArea.vue?vue&type=script&lang=js&"
export * from "./ServerErrorArea.vue?vue&type=script&lang=js&"
import style0 from "./ServerErrorArea.vue?vue&type=style&index=0&id=b112bd7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b112bd7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/uu264406/workDirectory/shingaku/reset_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b112bd7e')) {
      api.createRecord('b112bd7e', component.options)
    } else {
      api.reload('b112bd7e', component.options)
    }
    module.hot.accept("./ServerErrorArea.vue?vue&type=template&id=b112bd7e&scoped=true&", function () {
      api.rerender('b112bd7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/contents/components/common/common/ServerErrorArea.vue"
export default component.exports